import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { Login } from "@/features/auth";
import { ConfigProvider, fetchConfig } from "@/lib/config";
import { fetchUser } from "@/lib/user";

const loginSearchSchema = z.object({
  next: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  component: LoginPage,
  beforeLoad: async () => {
    const [user, config] = await Promise.all([fetchUser(), fetchConfig()]);
    if (user) {
      throw redirect({ to: "/" });
    }
    return { config };
  },
  validateSearch: loginSearchSchema,
});

function LoginPage() {
  const query = Route.useSearch();
  const { config } = Route.useRouteContext();
  return (
    <ConfigProvider config={config}>
      <Login {...query} />
    </ConfigProvider>
  );
}
